import {isCountryAt} from './utilities/country.mjs';

const configDe = {
  imageDirectoryPath: '',
  svgDirectoryPath: '',
};

const configAt = {
};

const config = (() => {
  let tempConfig = {};

  // window.EfConfig is declared as inline-script in project/Configuration/TypoScript/Setup/page.typoscript
  if (window.EfConfig) {
    tempConfig = Object.assign({}, configDe, window.EfConfig);
  }

  if (isCountryAt) {
    tempConfig =  Object.assign({}, tempConfig, configAt);
  }

  return tempConfig;
})();

export default config;
